<template>
  <div class="highchart-container">
    <highcharts
      :options="chartOptions"
    />
  </div>
</template>

<script>
import moment from 'moment';
import unitPreferencesMixin from '@shared/mixins/unitPreferencesMixin';

import convertToCelsiusResult from '@shared/lib/converter/convertToCelsiusResult';
import convertToCelsius from '@shared/lib/converter/convertToCelsius';

export default {
  name: 'DailyDeltaTGraph',
  mixins: [unitPreferencesMixin],
  props: {
    dailyStats: Array,
  },
  computed: {
    graphData() {
      const {
        partnerSettings: {
          TEMP_UNIT = '°F',
          DATE_FORMAT = 'MM-DD-YYYY',
        },
      } = this.$store.state.admin;

      const columnDate = [];
      const heatTemp = [];
      const coolTemp = [];
      const maxOATemp = [];
      const minOATemp = [];

      this.dailyStats.forEach((c) => {
        const {
          localDate,
          deltaT,
          maxTempAPI,
          minTempAPI,
        } = c;

        if (deltaT?.heat) {
          let temp = deltaT.heat;
          if (TEMP_UNIT === '°C') {
            temp = convertToCelsiusResult(temp);
          }
          heatTemp.push(temp);
        } else {
          heatTemp.push(null);
        }

        if (deltaT?.cool) {
          let temp = deltaT.cool;
          if (TEMP_UNIT === '°C') {
            temp = convertToCelsiusResult(temp);
          }
          coolTemp.push(temp);
        } else {
          coolTemp.push(null);
        }

        let max = maxTempAPI;
        if (TEMP_UNIT === '°C') {
          max = convertToCelsius(max);
        }
        let min = minTempAPI;
        if (TEMP_UNIT === '°C') {
          min = convertToCelsius(min);
        }

        let date = moment(localDate).format('M/D/YYYY');
        if (DATE_FORMAT === 'DD-MM-YYYY') {
          date = moment(localDate).format('D/M/YYYY');
        }
        maxOATemp.push(max);
        minOATemp.push(min);
        columnDate.push(date);
      });
      return {
        columnDate,
        heatTemp,
        coolTemp,
        minOATemp,
        maxOATemp,
      };
    },
    chartOptions() {
      const {
        tempFormat,
      } = this;

      const {
        columnDate,
        heatTemp,
        coolTemp,
        minOATemp,
        maxOATemp,
      } = this.graphData;

      return {
        chart: {
          zoomType: 'x',
          height: 400,
          backgroundColor: '#0f1734',
        },
        credits: {
          enabled: false,
        },
        title: {
          text: 'Performance',
          style: {
            color: 'white',
          },
        },
        tooltip: {
          useHTML: true,
          nullFormat: 'Value is not available.',
          formatter() {
            return `${this.x}<br/>`
              + `${this.series.name}: <b>${this.y}</b>`;
          },
        },
        xAxis: [{
          categories: columnDate,
          reversed: new Date(columnDate[0]) > new Date(columnDate[columnDate.length - 1]),
          title: {
            text: 'Days',
            style: {
              color: 'white',
            },
          },
          labels: {
            style: {
              color: 'white',
            },
          },
        }],
        yAxis: [{
          labels: {
            format: `{value}${tempFormat}`,
            style: {
              color: 'white',
            },
          },
          title: {
            text: 'Temperature',
            style: {
              color: 'white',
            },
          },
          min: Math.min(...heatTemp, ...coolTemp) - 4,
          max: Math.max(...heatTemp, ...coolTemp) + 4,
          opposite: false,
        },
        {
          labels: {
            format: `{value}${tempFormat}`,
            style: {
              color: 'white',
            },
          },
          title: {
            text: 'Outside Air Temperature',
            style: {
              color: 'white',
            },
          },
          min: Math.min(...minOATemp, ...maxOATemp) - 4,
          max: Math.max(...minOATemp, ...maxOATemp) + 4,
          opposite: true,
        }],
        legend: {
          shadow: false,
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: 0,
          itemStyle: {
            color: 'white',
          },
        },
        series: [{
          type: 'scatter',
          yAxis: 0,
          xAxis: 0,
          name: 'Cool',
          color: '#4979FF',
          data: coolTemp,
        }, {
          type: 'scatter',
          yAxis: 0,
          xAxis: 0,
          name: 'Heat',
          color: '#F7433A',
          data: heatTemp,
        }, {
          type: 'scatter',
          yAxis: 1,
          xAxis: 0,
          name: 'Max OA T',
          color: '#ffa500',
          data: maxOATemp,
        }, {
          type: 'scatter',
          yAxis: 1,
          xAxis: 0,
          name: 'Min OA T',
          color: '#ffdb9a',
          data: minOATemp,
        }],
      };
    },
  },
};
</script>

<style lang="scss">

</style>
